import React, { CSSProperties } from "react";
import { Container, Content, Text, SubText, Extra } from "./Styled";
import BaseChart from "../baseChart/BaseChart";
import { Progress } from "antd";

type NumberProps = {
    style?: CSSProperties | undefined;
    title: string;
    text?: string;
    subText?: string;
    Icon: React.ReactNode;
    color: any;
    ExtraInformation?: React.ReactNode;
    percent: number;
};

export const Number: React.FunctionComponent<NumberProps> = ({
    style,
    Icon,
    text,
    color,
    title,
    subText,
    ExtraInformation,
    percent
}) => {
    return (
        <Container style={style}>
            <BaseChart title={title}>
                <Content>
                    <Text>{text}<SubText>{subText}</SubText></Text>
                    <Progress
                        style={{ position: 'absolute', right: '10px' }}
                        width={90}
                        type="circle"
                        strokeColor={color}
                        percent={percent}
                        strokeWidth={3}
                        format={percent => Icon}
                    ></Progress>
                </Content>
                <Extra>
                    {ExtraInformation}
                </Extra>
            </BaseChart>
        </Container>
    );
};

export default Number;